import http from '@/utils/http'
import brand from '@/branding'

const currentBrandCode = brand.id

export const paymentAdminApi = {
  getPurchaseConfig(brandCode = currentBrandCode) {
    return http.get('/api/payment/purchase-config', { params: { brandCode } })
  },

  getAddOnOptions(brandCode = currentBrandCode) {
    return http.get('/api/payment/add-ons/options', { params: { brandCode } })
  },

  getMyProducts(brandCode = currentBrandCode) {
    return http.get('/api/payment/my-products', { params: { brandCode } })
  },

  getLicenceSummary(brandCode = currentBrandCode) {
    return http.get('/api/payment/licences/summary', { params: { brandCode } })
  },

  createAuditor(payload) {
    return http.post('/api/payment/auditors', { ...payload, brandCode: payload.brandCode || currentBrandCode })
  },

  createAddOnOrder(payload) {
    return http.post('/api/payment/add-ons/orders', { ...payload, brandCode: payload.brandCode || currentBrandCode })
  },

  getDashboard() {
    return http.get('/api/payment/admin/dashboard')
  },

  getCompanyEntitlements(params) {
    return http.get('/api/payment/admin/company-entitlements', { params })
  },

  getAuditOverview() {
    return http.get('/api/payment/admin/audit-overview')
  },

  getCatalogItems(params) {
    return http.get('/api/payment/admin/catalog-items', {
      params: { brandCode: currentBrandCode, ...(params || {}) }
    })
  },

  createCatalogItem(payload) {
    return http.post('/api/payment/admin/catalog-items', payload)
  },

  updateCatalogItem(id, payload) {
    return http.put(`/api/payment/admin/catalog-items/${id}`, payload)
  },

  enableCatalogItem(id, brandCode = currentBrandCode) {
    return http.put(`/api/payment/admin/catalog-items/${id}/enable`, null, { params: { brandCode } })
  },

  disableCatalogItem(id, brandCode = currentBrandCode) {
    return http.put(`/api/payment/admin/catalog-items/${id}/disable`, null, { params: { brandCode } })
  },

  getOrders(params) {
    return http.get('/api/payment/admin/orders', {
      params: { brandCode: currentBrandCode, ...(params || {}) }
    })
  },

  getOrder(orderNo, brandCode = currentBrandCode) {
    return http.get(`/api/payment/admin/orders/${orderNo}`, { params: { brandCode } })
  },

  syncOrderStatus(orderNo, brandCode = currentBrandCode) {
    return http.post(`/api/payment/admin/orders/${orderNo}/sync-status`, null, { params: { brandCode } })
  },

  updateOrderInvoice(orderNo, payload, brandCode = currentBrandCode) {
    return http.put(`/api/payment/admin/orders/${orderNo}/invoice`, payload, { params: { brandCode } })
  },

  uploadInvoiceFile(formData) {
    return http.post('/api/payment/oss/files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  getInvoiceFile(fileId, params) {
    return http.get(`/api/payment/oss/files/${fileId}`, { params })
  },

  deleteInvoiceFile(fileId) {
    return http.delete(`/api/payment/oss/files/${fileId}`)
  }
}
